export default [
  {
    field: {
      id: 'name',
      label_en: 'Name',
      label_ru: 'Имя',
      name: 'name',
      type: 'text',
      max: 30,
      min: 1,
    },
    required: true,
    order: -1,
  },
  {
    field: {
      id: 'surname',
      label_en: 'Surname',
      label_ru: 'Фамилия',
      name: 'surname',
      type: 'text',
      max: 30,
      min: 1,
    },
    required: true,
    order: -1,
  },
  {
    field: {
      id: 'email',
      label_en: 'Email',
      label_ru: 'Email',
      name: 'email',
      type: 'text',
    },
    required: true,
    order: -3,
  },
  // {
  //   field: {
  //     id: 'patronymic',
  //     label_en: 'Patronymic',
  //     label_ru: 'Отчество',
  //     name: 'patronymic',
  //     type: 'text',
  //     max: 30,
  //     min: 1,
  //   },
  //   order: -1,
  // },
];
